const Notifications = {
  APPLICATION: "Application",
  VACANCY: "Vacancy",
  VACANCY_RECRUITER: "Vacancy-recruiter",
};

export const getNotificationTitle = (arg: string) => {
  switch (arg) {
    case Notifications.APPLICATION:
      return "Создана новая заявка";
    case Notifications.VACANCY:
      return "Создана новая вакансия";
    case Notifications.VACANCY_RECRUITER:
      return "Назначение на вакансию";
    default:
      return "";
  }
};

export const getNotificationBtnLink = (model: string, id: number) => {
  switch (model) {
    case Notifications.APPLICATION:
      return `/applications/${id}`;
    case Notifications.VACANCY:
      return `/vacancy/${id}`;
    case Notifications.VACANCY_RECRUITER:
      return `/vacancy/${id}`;
    default:
      return "";
  }
};
